module.exports = __webpack_public_path__ + "static/img/loading.ede1de08.png";